import React from 'react'
import './style.scss'

import { ContainerModal } from './../../components/Layout'
import { ValidacaoYup } from './../../components/Form'

function Relatorio() {

    return (
        <>
            <ContainerModal
                route='contatos'
                title='Contatos Linkedin'
                showButtonExcluir={false}
                showButtonEditar={false}
                showButtonNovo={false}
                showButtonPagination={false}
                campos={[
                    { nome: 'Nome' },
                    { nome: 'Empresa' },
                    { nome: 'Setor' },
                    { nome: 'E-mail' }
                ]}
                validacao={{
                    nome: ValidacaoYup.string().required(),
                    status: ValidacaoYup.string().min(1).required()
                }}
                onNovoBefore={setData => {
                    setData({
                        status: { value: 'A', label: 'Ativo' }
                    })
                }}
            >

            </ContainerModal>
        </>
    )
}

export default Relatorio